import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ResponsiveLayoutService } from 'src/app/services/responsive-layout.service';
import { ScheduleAdmin } from 'src/app/models/schedule';
import { ExcelService } from 'src/app/services/excel.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdminTableComponent } from 'src/app/shared/admin-table/admin-table.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css'],
})
export class ScheduleComponent implements OnInit {
  @ViewChild('table') table!: AdminTableComponent<ScheduleAdmin>;
  @ViewChild('uploadModal') uploadModal!: ElementRef;
  @ViewChild('confirmModal') confirmModal!: ElementRef;

  file: File | null = null;
  fileName = '';
  fileError = false;
  data$ = 'schedules/';
  mapHeader = {
    id: { display: 'Id', data: null },
    plant: { display: 'Planta', data: null },
    day: { display: 'Día', data: null },
    date: { display: 'Fecha', data: null },
    schedule_range: { display: 'Rango Horario', data: null },
  };

  constructor(
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private storeService: StoreService,
    private excelService: ExcelService
  ) {}

  ngOnInit(): void {}

  openUploadModal(): void {
    this.modalService.open(this.uploadModal, { centered: true });
  }

  openConfirmModal(): void {
    if (this.file) {
      this.modalService.open(this.confirmModal, { centered: true });
    }
  }

  triggerFileInput(): void {
    document.getElementById('customFile')?.click();
  }

  onFileChange(event: any): void {
    const selectedFile = event.target.files[0];
    const allowedExtensions = /\.csv$/i;

    if (selectedFile) {
      if (!allowedExtensions.exec(selectedFile.name)) {
        this.fileError = true;
        this.fileName = '';
        this.file = null;
        event.target.value = '';
      } else {
        this.fileError = false;
        this.file = selectedFile;
        this.fileName = selectedFile.name;
      }
    }
  }

  uploadFile(): void {
    if (!this.file) return;

    const reader = new FileReader();
    this.spinner.show();

    reader.onload = (e: any) => {
      const content = e.target.result as string;
      const data = content.split('\r\n');
      const header = data[0].split(',');
      const importedData = data.slice(1, -1);

      const disponibilidad = importedData.map((row) => {
        const values = row.split(',');
        const obj: { [key: string]: string } = {};
        header.forEach((key, i) => {
          obj[key] = values[i];
        });
        return obj;
      });

      this.storeService.post_import_schedule(disponibilidad).subscribe({
        next: () => {
          this.spinner.hide();
          this.modalService.dismissAll();
          this.table.reload();
        },
        error: () => {
          this.spinner.hide();
          alert('Error al subir el archivo');
        },
      });
    };

    reader.readAsText(this.file);
  }
}
